import { Navigate, Outlet, useLocation } from 'react-router-dom';
import './DashboardLayout.css'
import { useAuth } from '../../context/AuthContext';

const DashboardLayout = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div key={location.key} className='dashboard-layout dashboard'>
        <Outlet />
    </div>
    );
};

export default DashboardLayout;